<article
    [id]="'socialPostDetails.article'"
    class="agpr-socialPostArticle"
>
    <div class="agpr-socialPostArticle-container">
        <section
            class="agpr-socialPostArticle-section"
            *ngIf="mention.handle || mention.mediaType.id === mediaTypeEnum.YOUTUBE"
        >
            <div class="agpr-socialPostArticle-label">{{ 'Social.post.article.postedBy' | localize }}</div>
            <div
                *ngIf="mention.handle && (mention.mediaType.id !== mediaTypeEnum.YOUTUBE)"
                class="agpr-socialPostArticle-link"
                [innerHtml]="mention.handle | mentionLinks:mention.mediaType.id"
            >
            </div>
            <div>
                <a
                    *ngIf="mention.mediaType.id === mediaTypeEnum.YOUTUBE && mention?.socialUrl"
                    [href]="mention?.socialUrl"
                    target="_blank"
                >
                    {{ mention?.username ? mention?.username : mention?.author?.name}}
                </a>
            </div>
            <span
                *ngIf="mention.mediaType.id === mediaTypeEnum.YOUTUBE && !mention?.socialUrl"
            >
                {{ mention?.username ? mention?.username : mention?.author?.name}}
            </span>
        </section>
        <section class="agpr-socialPostArticle-section">
            <div class="agpr-socialPostArticle-label">{{ 'Social.post.article.datePublished' | localize }}</div>
            <div class="agpr-socialPostArticle-value">{{ mention.datePublished | changeTimeZone: preferences.timeZone: dateFormat }}</div>
        </section>
        <section class="agpr-socialPostArticle-section">
            <div class="agpr-socialPostArticle-label">{{ 'Social.post.article.dateAvailable' | localize }}</div>
            <div class="agpr-socialPostArticle-value">{{ mention.dateAvailable | changeTimeZone: preferences.timeZone: dateFormat }}</div>
        </section>
    </div>

    <section class="agpr-socialPostArticle-body">
        <p
            *ngIf="mention?.headline"
            class="agpr-socialPostArticle-paragraph"
            [ngClass]="{'agpr-socialPostArticle-paragraphHeadline': mention?.body}"
            [innerHTML]="mention?.headline | mentionLinks:mention?.mediaType.id | highlightKeywords: highlightKeywords"
        >
        </p>
        <p
            class="agpr-socialPostArticle-paragraph"
            *ngFor="let paragraph of bodyParagraphs"
            [innerHTML]="paragraph | mentionLinks:mention.mediaType.id | highlightKeywords: highlightKeywords"
        ></p>
    </section>
</article>
